module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3qEJq"))).then(() => parcelRequire('1iHdE'));